import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import clienteAxios from '../helpers/axios.helper';

function Marcas() {
  const navigate = useNavigate();
  const [marcas, setMarcas] = useState([]);
  const [loading, setLoading] = useState(true); // Para manejar el estado de carga
  const [error, setError] = useState(null); // Para manejar errores

  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const response = await clienteAxios.get('/marcas'); // Cambia la URL por la de tu API
        setMarcas(response.data); // Ajusta esta línea según la estructura de tu respuesta
      } catch (err) {
        setError('No se pudieron cargar las marcas. Inténtalo más tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchMarcas();
  }, []);

  const handleRedirect = (id, nombre) => {
    navigate(`/productos/${nombre}`, { state: { id: id, marcas: marcas } });
  };

  return (
    <div className='flex flex-col items-center min-h-screen p-8'>
      <h2 className="text-3xl font-bold text-center mb-6">Marcas que nos acompañan</h2>
      <div className='flex-grow w-4/5 flex flex-wrap justify-center items-center relative mb-10'>
        {loading ? (
          <p className='text-xl text-GrisOscuro font-2xl'>Cargando marcas...</p>
        ) : error ? (
          <p className='text-xl text-GrisOscuro font-2xl'>{error}</p>
        ) : marcas.length > 0 ? (
          marcas.map((marca, index) => (
            <button
              onClick={() => handleRedirect(marca.id, marca.nombre)}
              key={index}
              className='border border-Negro w-80 m-4 flex flex-col items-center rounded-xl shadow-md shadow-GrisOscuro/50 hover:shadow-2xl hover:shadow-Negro/50'
            >
              <img src={marca.imagen} alt={marca.nombre} className='w-44 h-44 object-contain' />
              <label className='mt-2 text-GrisOscuro text-center p-2 text-xl font-semibold'>
                {marca.nombre}
              </label>
            </button>
          ))
        ) : (
          <p className='text-xl text-GrisOscuro font-2xl'>
            No hay marcas cargadas por el momento.
          </p>
        )}
      </div>
    </div>
  );
}

export default Marcas;
